import type VectorLayer from 'ol/layer/Vector'
import type VectorSource from 'ol/source/Vector'
import type Geometry from 'ol/geom/Geometry'
import type Feature from 'ol/Feature'

import { createNonBlockingRenderByTime } from '../../../renderingQueue'
import { setLayerMetadata } from '../../layerMetadata'

import { findTrafficAreaMarker } from './findTrafficAreaMarker'
import { createTrafficAreaFeature } from './createTrafficAreaFeature'

const nonblockingRender = createNonBlockingRenderByTime()

/**
 * Add new Features for all the Regions marked for creation in a Changelog coming form the data-layer
 */
export async function changelogAddTrafficAreaFeatures(
  layer: VectorLayer<VectorSource>,
  trafficProfiles: uui.domain.ui.map.markers.MapMarkers['trafficProfile'],
  mapStyles: uui.domain.ui.map.markers.MapStyles['trafficProfile'],
  selection: Set<string>,
  trafficProfileIds: IterableIterator<string>,
) {
  const features: Feature<Geometry>[] = []

  nonblockingRender.reset()

  for (const profileId of trafficProfileIds) {
    for (const markerId in trafficProfiles[profileId]) {
      await nonblockingRender.next()
      const marker = findTrafficAreaMarker(trafficProfiles[profileId], markerId)
      const selected = selection.has(profileId)

      features.push(createTrafficAreaFeature(marker, mapStyles, selected))
    }
  }

  // add all new features to the layer
  layer.getSource()?.addFeatures(features)

  // update the stored collection
  setLayerMetadata(layer, 'selection', selection)
}
